/* Aurelliani image view for the product gallery (Broadcast-style). Styles: snippets/au-lightbox.liquid.
   The photo grows from its place on the page (FLIP with a clip, so cropped gallery tiles open cleanly),
   zooms to the full-size file on click and pans with the mouse; pinch, double-tap, swipe on touch;
   shrinks back into the gallery on close. Reads the gallery when it opens, so variant changes are fine. */
(function () {
  'use strict';

  var DUR = 330;
  var EASE = 'cubic-bezier(.2,.7,.2,1)';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SVG_CHEV_L = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M8 1 3 6l5 5" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>';
  var SVG_CHEV_R = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="m4 1 5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>';
  var SVG_X = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="m2 2 12 12M14 2 2 14" fill="none" stroke="currentColor" stroke-width="1.1"/></svg>';

  var ui = null;
  var st = { open: false, busy: false, items: [], i: 0, source: null, img: null, fit: null, cur: null, tgt: null, raf: 0, mouse: null };

  /* ---------- the gallery on the page ---------- */
  function gallery() {
    var g = document.querySelector('main media-gallery');
    return g && !g.closest('dialog') ? g : null;
  }
  function itemsOf(g) {
    if (!g) return [];
    var grid = g.querySelector('.media-gallery__grid');
    var list = grid && grid.getClientRects().length
      ? grid.querySelectorAll(':scope > li.product-media-container--image')
      : g.querySelectorAll('slideshow-slide.product-media-container--image');
    return Array.prototype.filter.call(list, function (el) { return !el.hidden && el.querySelector('img'); });
  }
  function sizedUrl(src, w) {
    if (!src) return '';
    try {
      var u = new URL(src, location.href);
      if (u.pathname.indexOf('/cdn/') === -1 && u.hostname.indexOf('shopify') === -1) return u.href;
      u.searchParams.set('width', String(w));
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      return u.href;
    } catch (e) { return src; }
  }
  function info(el, n) {
    var img = el.querySelector('img');
    var src = img.currentSrc || img.getAttribute('src') || '';
    var w = img.naturalWidth || +img.getAttribute('width') || 1;
    var h = img.naturalHeight || +img.getAttribute('height') || 1;
    return {
      el: el,
      src: src,
      full: sizedUrl(src, 2400),
      thumb: sizedUrl(src, 200),
      ratio: w / h,
      alt: img.getAttribute('alt') || (title() + ', image ' + (n + 1))
    };
  }
  function title() {
    var h = document.querySelector('main .product-details h1, main h1');
    var m = document.querySelector('meta[property="og:title"]');
    return ((h && h.textContent) || (m && m.content) || document.title || '').trim();
  }

  /* make every gallery photo a keyboard target */
  function prep() {
    var list = itemsOf(gallery());
    list.forEach(function (el, n) {
      if (el.hasAttribute('data-au-lb')) return;
      el.setAttribute('data-au-lb', '');
      el.setAttribute('tabindex', '0');
      el.setAttribute('role', 'button');
      el.setAttribute('aria-label', 'Open image ' + (n + 1) + ' of ' + list.length + ' in full view');
    });
  }

  /* ---------- geometry ---------- */
  function vw() { return document.documentElement.clientWidth || window.innerWidth; }
  function vh() { return window.innerHeight; }
  function phone() { return vw() < 750; }
  function fitRect(ratio) {
    var p = phone();
    var top = p ? 64 : 88, bottom = st.items.length > 1 ? (p ? 92 : 128) : (p ? 24 : 40), side = p ? 0 : 104;
    var aw = vw() - side * 2, ah = vh() - top - bottom;
    var w = aw, h = w / ratio;
    if (h > ah) { h = ah; w = h * ratio; }
    return { x: (vw() - w) / 2, y: top + (ah - h) / 2, w: w, h: h };
  }
  /* where the photo is drawn inside its gallery tile (object-fit cover / contain), and the visible box */
  function sourceGeom(it) {
    var img = it.el.querySelector('img');
    if (!img) return null;
    var box = img.getBoundingClientRect();
    var tile = it.el.getBoundingClientRect();
    if (box.width < 2 || box.height < 2) return null;
    var cs = getComputedStyle(img);
    var r = it.ratio, bw = box.width, bh = box.height, dw, dh;
    if (cs.objectFit === 'contain' ? (bw / bh > r) : (bw / bh < r)) { dh = bh; dw = bh * r; } else { dw = bw; dh = bw / r; }
    var pos = (cs.objectPosition || '50% 50%').split(' ');
    var px = parseFloat(pos[0]) / 100, py = parseFloat(pos[1] || pos[0]) / 100;
    if (isNaN(px)) px = 0.5;
    if (isNaN(py)) py = 0.5;
    var drawn = { x: box.left + (bw - dw) * px, y: box.top + (bh - dh) * py, w: dw, h: dh };
    var vis = {
      l: Math.max(box.left, tile.left, drawn.x, 0),
      t: Math.max(box.top, tile.top, drawn.y, 0),
      r: Math.min(box.right, tile.right, drawn.x + dw, vw()),
      b: Math.min(box.bottom, tile.bottom, drawn.y + dh, vh())
    };
    if (vis.r - vis.l < 2 || vis.b - vis.t < 2) return null;
    return { drawn: drawn, vis: vis };
  }
  /* transform + clip that put the fit-sized image exactly over the gallery tile */
  function fromSource(g, f) {
    var s = g.drawn.w / f.w;
    var clip = 'inset(' + [(g.vis.t - g.drawn.y) / s, (g.drawn.x + g.drawn.w - g.vis.r) / s, (g.drawn.y + g.drawn.h - g.vis.b) / s, (g.vis.l - g.drawn.x) / s].map(function (v) { return Math.max(0, v).toFixed(2) + 'px'; }).join(' ') + ')';
    return { transform: tf(g.drawn.x, g.drawn.y, s), clipPath: clip };
  }
  function tf(x, y, s) { return 'translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px,0) scale(' + s.toFixed(4) + ')'; }

  /* ---------- the view ---------- */
  function build() {
    if (ui) return ui;
    var d = document.createElement('dialog');
    d.className = 'au-lb';
    d.setAttribute('aria-modal', 'true');
    d.innerHTML =
      '<div class="au-lb__bg"></div>' +
      '<div class="au-lb__stage"></div>' +
      '<button type="button" class="au-lb__back au-lb__ui au-lb__ui--hide-on-zoom">' + SVG_CHEV_L + '<span></span></button>' +
      '<button type="button" class="au-lb__close au-lb__ui" aria-label="Close">' + SVG_X + '</button>' +
      '<button type="button" class="au-lb__nav au-lb__nav--prev au-lb__ui au-lb__ui--hide-on-zoom" aria-label="Previous image">' + SVG_CHEV_L + '</button>' +
      '<button type="button" class="au-lb__nav au-lb__nav--next au-lb__ui au-lb__ui--hide-on-zoom" aria-label="Next image">' + SVG_CHEV_R + '</button>' +
      '<div class="au-lb__thumbs au-lb__ui au-lb__ui--hide-on-zoom" role="list"></div>' +
      '<p class="au-lb__sr" aria-live="polite"></p>';
    document.body.appendChild(d);
    ui = {
      d: d,
      bg: d.querySelector('.au-lb__bg'),
      stage: d.querySelector('.au-lb__stage'),
      back: d.querySelector('.au-lb__back'),
      close: d.querySelector('.au-lb__close'),
      prev: d.querySelector('.au-lb__nav--prev'),
      next: d.querySelector('.au-lb__nav--next'),
      thumbs: d.querySelector('.au-lb__thumbs'),
      live: d.querySelector('.au-lb__sr')
    };
    ui.back.addEventListener('click', close);
    ui.close.addEventListener('click', close);
    ui.prev.addEventListener('click', function () { go(st.i - 1); });
    ui.next.addEventListener('click', function () { go(st.i + 1); });
    ui.thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('.au-lb__thumb');
      if (b) go(+b.dataset.i);
    });
    d.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(st.i - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(st.i + 1); }
    });
    gestures(d);
    window.addEventListener('resize', function () { if (st.open && !st.busy) layout(); });
    return ui;
  }

  function fillChrome() {
    var t = title();
    ui.back.querySelector('span').textContent = t;
    ui.back.setAttribute('aria-label', 'Back to ' + t);
    ui.d.setAttribute('aria-label', t + ' images');
    ui.thumbs.innerHTML = '';
    st.items.forEach(function (it, n) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'au-lb__thumb';
      b.dataset.i = n;
      b.setAttribute('role', 'listitem');
      b.setAttribute('aria-label', 'Show image ' + (n + 1) + ' of ' + st.items.length);
      var im = document.createElement('img');
      im.src = it.thumb;
      im.alt = '';
      im.loading = 'lazy';
      im.decoding = 'async';
      b.appendChild(im);
      ui.thumbs.appendChild(b);
    });
    var many = st.items.length > 1;
    ui.thumbs.hidden = !many;
    ui.prev.hidden = !many;
    ui.next.hidden = !many;
  }

  function markThumb() {
    Array.prototype.forEach.call(ui.thumbs.children, function (b, n) {
      if (n === st.i) { b.setAttribute('aria-current', 'true'); b.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
      else b.removeAttribute('aria-current');
    });
    ui.live.textContent = 'Image ' + (st.i + 1) + ' of ' + st.items.length;
  }

  function makeImg(it) {
    var im = document.createElement('img');
    im.className = 'au-lb__img';
    im.alt = it.alt;
    im.draggable = false;
    im.decoding = 'async';
    im.src = it.src;
    var f = fitRect(it.ratio);
    im.style.width = f.w + 'px';
    im.style.height = f.h + 'px';
    im.style.transform = tf(f.x, f.y, 1);
    /* swap in the full-size file once it has loaded */
    if (it.full && it.full !== it.src) {
      var hi = new Image();
      hi.decoding = 'async';
      hi.onload = function () {
        var done = function () { if (im.isConnected) im.src = it.full; };
        if (hi.decode) hi.decode().then(done, done); else done();
      };
      hi.src = it.full;
    }
    return { el: im, it: it, f: f };
  }

  function setCur(x, y, s) {
    st.cur = { x: x, y: y, s: s };
    st.img.el.style.transform = tf(x, y, s);
    ui.d.classList.toggle('is-zoomed', s > 1.01);
  }

  /* ---------- open ---------- */
  function open(el) {
    var g = gallery();
    var list = itemsOf(g);
    var idx = list.indexOf(el);
    if (idx < 0 || st.open || st.busy) return;
    build();
    st.items = list.map(info);
    st.i = idx;
    st.source = el;
    st.open = true;
    st.busy = true;
    fillChrome();
    ui.stage.innerHTML = '';
    st.img = makeImg(st.items[idx]);
    ui.stage.appendChild(st.img.el);
    var f = st.img.f;
    st.cur = { x: f.x, y: f.y, s: 1 };
    st.tgt = null;
    markThumb();

    var geom = sourceGeom(st.items[idx]);
    document.documentElement.setAttribute('scroll-lock', '');
    ui.d.showModal();
    ui.d.focus({ preventScroll: true });
    ui.d.classList.remove('is-zoomed');
    requestAnimationFrame(function () { ui.d.classList.add('is-open'); });

    var srcImg = el.querySelector('img');
    var finish = function () {
      ui.bg.getAnimations().forEach(function (a) { a.cancel(); });
      ui.bg.style.opacity = '1';
      st.busy = false;
      if (srcImg) srcImg.style.visibility = '';
      st.img.el.style.clipPath = '';
    };
    if (reduce.matches || !geom) {
      ui.bg.animate([{ opacity: 0 }, { opacity: 1 }], { duration: reduce.matches ? 200 : 260, easing: 'ease', fill: 'forwards' });
      st.img.el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: reduce.matches ? 200 : 260, easing: 'ease' }).finished.then(finish, finish);
      return;
    }
    if (srcImg) srcImg.style.visibility = 'hidden';
    var from = fromSource(geom, f);
    ui.bg.animate([{ opacity: 0 }, { opacity: 1 }], { duration: DUR, easing: 'ease-out', fill: 'forwards' });
    st.img.el.animate([from, { transform: tf(f.x, f.y, 1), clipPath: 'inset(0px 0px 0px 0px)' }], { duration: DUR, easing: EASE })
      .finished.then(finish, finish);
  }

  /* ---------- close ---------- */
  function close() {
    if (!st.open || st.busy) return;
    st.busy = true;
    stopLoop();
    var it = st.items[st.i];
    /* bring that photo into view in the page gallery first */
    var g = gallery();
    if (g && it.el.tagName === 'SLIDESHOW-SLIDE' && g.slideshow && typeof g.slideshow.select === 'function') {
      var slides = Array.prototype.slice.call(g.slideshow.slides || it.el.parentNode.children);
      var at = slides.indexOf(it.el);
      if (at > -1) { try { g.slideshow.select(at, undefined, { animate: false }); } catch (e) {} }
    }
    var r = it.el.getBoundingClientRect();
    if (r.bottom < 40 || r.top > vh() - 40) it.el.scrollIntoView({ block: 'center', behavior: 'instant' });

    requestAnimationFrame(function () {
      var geom = it.el.isConnected ? sourceGeom(it) : null;
      var im = st.img.el;
      var srcImg = it.el.querySelector('img');
      var cur = st.cur;
      ui.d.classList.remove('is-open');
      var end = function () {
        if (srcImg) srcImg.style.visibility = '';
        ui.d.close();
        ui.d.classList.remove('is-zoomed');
        ui.stage.innerHTML = '';
        document.documentElement.removeAttribute('scroll-lock');
        ui.bg.getAnimations().forEach(function (a) { a.cancel(); });
        ui.bg.style.opacity = '';
        st.open = false;
        st.busy = false;
        st.img = null;
        if (it.el.isConnected) it.el.focus({ preventScroll: true });
        else if (st.source && st.source.isConnected) st.source.focus({ preventScroll: true });
      };
      var bgFrom = getComputedStyle(ui.bg).opacity;
      if (reduce.matches || !geom) {
        ui.bg.animate([{ opacity: bgFrom }, { opacity: 0 }], { duration: 220, easing: 'ease', fill: 'forwards' });
        im.animate([{ opacity: getComputedStyle(im).opacity }, { opacity: 0 }], { duration: 220, easing: 'ease', fill: 'forwards' }).finished.then(end, end);
        return;
      }
      var to = fromSource(geom, st.img.f);
      ui.bg.animate([{ opacity: bgFrom }, { opacity: 0 }], { duration: DUR, easing: 'ease-in', fill: 'forwards' });
      im.animate([{ transform: tf(cur.x, cur.y, cur.s), clipPath: 'inset(0px 0px 0px 0px)', opacity: getComputedStyle(im).opacity }, { transform: to.transform, clipPath: to.clipPath, opacity: 1 }], { duration: DUR, easing: EASE, fill: 'forwards' })
        .finished.then(function () {
          if (srcImg) srcImg.style.visibility = '';
          requestAnimationFrame(end);
        }, end);
      if (srcImg) srcImg.style.visibility = 'hidden';
    });
  }

  /* ---------- switch photo ---------- */
  function go(n) {
    if (!st.open || st.busy || st.items.length < 2) return;
    var count = st.items.length;
    var dir = n > st.i ? 1 : -1;
    n = (n + count) % count;
    if (n === st.i) return;
    stopLoop();
    var old = st.img;
    var oc = st.cur;
    st.i = n;
    st.img = makeImg(st.items[n]);
    var f = st.img.f;
    ui.stage.appendChild(st.img.el);
    st.cur = { x: f.x, y: f.y, s: 1 };
    ui.d.classList.remove('is-zoomed');
    markThumb();
    var d = reduce.matches ? 0 : Math.min(90, vw() * 0.12);
    var dur = reduce.matches ? 160 : 260;
    st.busy = true;
    old.el.animate([{ transform: tf(oc.x, oc.y, oc.s), opacity: getComputedStyle(old.el).opacity }, { transform: tf(oc.x - dir * d, oc.y, oc.s), opacity: 0 }], { duration: dur, easing: EASE, fill: 'forwards' })
      .finished.then(function () { old.el.remove(); }, function () { old.el.remove(); });
    st.img.el.animate([{ transform: tf(f.x + dir * d, f.y, 1), opacity: 0 }, { transform: tf(f.x, f.y, 1), opacity: 1 }], { duration: dur, easing: EASE })
      .finished.then(function () { st.busy = false; }, function () { st.busy = false; });
  }

  function layout() {
    var it = st.items[st.i];
    var f = fitRect(it.ratio);
    st.img.f = f;
    st.img.el.style.width = f.w + 'px';
    st.img.el.style.height = f.h + 'px';
    stopLoop();
    setCur(f.x, f.y, 1);
  }

  /* ---------- zoom + pan ---------- */
  /* a zoomed photo that is smaller than the screen on one axis stays centred on the fit position there */
  function centre(s) {
    var f = st.img.f, W = f.w * s, H = f.h * s;
    return {
      x: Math.min(Math.max(f.x + (f.w - W) / 2, Math.min(0, vw() - W)), Math.max(0, vw() - W)),
      y: Math.min(Math.max(f.y + (f.h - H) / 2, Math.min(0, vh() - H)), Math.max(0, vh() - H))
    };
  }
  function bounds(s) {
    var f = st.img.f, W = f.w * s, H = f.h * s, V = vw(), Hh = vh(), c = centre(s);
    return {
      minX: W > V ? V - W : c.x, maxX: W > V ? 0 : c.x,
      minY: H > Hh ? Hh - H : c.y, maxY: H > Hh ? 0 : c.y
    };
  }
  function clampPos(x, y, s) {
    var b = bounds(s);
    return { x: Math.min(b.maxX, Math.max(b.minX, x)), y: Math.min(b.maxY, Math.max(b.minY, y)), s: s };
  }
  function zoomScale() { var f = st.img.f; return Math.min(Math.max(vw() / f.w, 1.6), 4); }
  function panTarget(mx, my, s) {
    if (s <= 1.001) return fitTarget();
    var f = st.img.f, W = f.w * s, H = f.h * s, V = vw(), Hh = vh(), c = centre(s);
    return {
      x: W > V ? -(mx / V) * (W - V) : c.x,
      y: H > Hh ? -(my / Hh) * (H - Hh) : c.y,
      s: s
    };
  }
  function loop() {
    st.raf = 0;
    if (!st.open || !st.tgt || !st.img) return;
    var k = reduce.matches ? 1 : 0.22, c = st.cur, t = st.tgt;
    var x = c.x + (t.x - c.x) * k, y = c.y + (t.y - c.y) * k, s = c.s + (t.s - c.s) * k;
    if (Math.abs(t.x - x) < 0.5 && Math.abs(t.y - y) < 0.5 && Math.abs(t.s - s) < 0.004) { x = t.x; y = t.y; s = t.s; }
    setCur(x, y, s);
    if (x !== t.x || y !== t.y || s !== t.s) st.raf = requestAnimationFrame(loop);
  }
  function animateTo(t) {
    st.tgt = t;
    if (!st.raf) st.raf = requestAnimationFrame(loop);
  }
  function stopLoop() {
    if (st.raf) cancelAnimationFrame(st.raf);
    st.raf = 0;
    st.tgt = null;
    if (st.img) st.img.el.getAnimations().forEach(function (a) { a.cancel(); });
  }
  function fitTarget() { var f = st.img.f; return { x: f.x, y: f.y, s: 1 }; }
  function zoomed() { return st.cur && st.cur.s > 1.01; }

  /* ---------- pointer + touch ---------- */
  function gestures(d) {
    var pts = new Map();
    var g = null; /* current gesture */
    var lastTap = { t: 0, x: 0, y: 0 };

    d.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || !st.open || st.busy || !zoomed() || !st.tgt) return;
      animateTo(panTarget(e.clientX, e.clientY, st.tgt.s));
    });

    d.addEventListener('click', function (e) {
      if (!st.open || st.busy || st.lastPointer !== 'mouse') return;
      if (e.target === st.img.el) {
        if (zoomed()) animateTo(fitTarget());
        else animateTo(panTarget(e.clientX, e.clientY, zoomScale()));
      } else if (e.target === ui.bg || e.target === ui.stage) {
        if (zoomed()) animateTo(fitTarget()); else close();
      }
    });

    d.addEventListener('pointerdown', function (e) {
      st.lastPointer = e.pointerType;
      if (e.pointerType === 'mouse' || !st.open || st.busy) return;
      if (e.target.closest('button')) return;
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      stopLoop();
      if (pts.size === 1) {
        g = { kind: 'one', x0: e.clientX, y0: e.clientY, t0: performance.now(), c0: { x: st.cur.x, y: st.cur.y, s: st.cur.s }, axis: null, moved: false };
      } else if (pts.size === 2) {
        var p = Array.from(pts.values());
        var mid = { x: (p[0].x + p[1].x) / 2, y: (p[0].y + p[1].y) / 2 };
        g = { kind: 'pinch', d0: dist(p[0], p[1]), s0: st.cur.s, local: { x: (mid.x - st.cur.x) / st.cur.s, y: (mid.y - st.cur.y) / st.cur.s }, moved: true };
        resetSwipe();
      }
    });

    d.addEventListener('pointermove', function (e) {
      if (!pts.has(e.pointerId) || !g || !st.img) return;
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (g.kind === 'pinch' && pts.size >= 2) {
        var p = Array.from(pts.values());
        var mid = { x: (p[0].x + p[1].x) / 2, y: (p[0].y + p[1].y) / 2 };
        var s = Math.min(5, Math.max(0.8, g.s0 * dist(p[0], p[1]) / g.d0));
        setCur(mid.x - g.local.x * s, mid.y - g.local.y * s, s);
        return;
      }
      if (g.kind !== 'one') return;
      var dx = e.clientX - g.x0, dy = e.clientY - g.y0;
      if (!g.moved && Math.hypot(dx, dy) > 8) g.moved = true;
      if (!g.moved) return;
      if (g.c0.s > 1.01) { /* pan the zoomed photo */
        var c = clampPos(g.c0.x + dx, g.c0.y + dy, g.c0.s);
        setCur(c.x, c.y, c.s);
        return;
      }
      if (!g.axis) g.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : (dy > 0 ? 'down' : 'up');
      var f = st.img.f;
      if (g.axis === 'x' && st.items.length > 1) {
        setCur(f.x + dx, f.y, 1);
        st.img.el.style.opacity = String(1 - Math.min(0.5, Math.abs(dx) / vw()));
      } else if (g.axis === 'down') {
        var k = Math.max(0, dy);
        var sc = 1 - Math.min(0.25, k / 1600);
        setCur(f.x + dx * 0.4 + (f.w * (1 - sc)) / 2, f.y + k, sc);
        ui.bg.style.opacity = String(1 - Math.min(0.85, k / 420));
      }
    });

    function end(e) {
      if (!pts.has(e.pointerId)) return;
      pts.delete(e.pointerId);
      if (!g || !st.img) return;
      if (g.kind === 'pinch') {
        if (pts.size === 0) {
          var s = Math.min(4, st.cur.s);
          if (s <= 1.05) animateTo(fitTarget());
          else animateTo(clampPos(st.cur.x, st.cur.y, s));
          g = null;
        }
        return;
      }
      var dx = e.clientX - g.x0, dy = e.clientY - g.y0, dt = performance.now() - g.t0;
      var vx = dx / Math.max(1, dt);
      var gg = g;
      g = null;
      if (!gg.moved) { tap(e.clientX, e.clientY); return; }
      if (gg.c0.s > 1.01) return;
      if (gg.axis === 'x' && st.items.length > 1) {
        st.img.el.style.opacity = '';
        if (Math.abs(dx) > vw() * 0.18 || Math.abs(vx) > 0.45) { go(st.i + (dx < 0 ? 1 : -1)); return; }
        animateTo(fitTarget());
        return;
      }
      if (gg.axis === 'down') {
        if (dy > 110 || dy / Math.max(1, dt) > 0.5) { close(); return; }
        ui.bg.style.opacity = '1';
        animateTo(fitTarget());
        return;
      }
      animateTo(fitTarget());
    }
    d.addEventListener('pointerup', end);
    d.addEventListener('pointercancel', end);

    function tap(x, y) {
      var now = performance.now();
      if (now - lastTap.t < 320 && Math.hypot(x - lastTap.x, y - lastTap.y) < 40) {
        lastTap.t = 0;
        if (zoomed()) { animateTo(fitTarget()); return; }
        var s = Math.min(Math.max(2.5, zoomScale()), 4);
        var local = { x: (x - st.cur.x) / st.cur.s, y: (y - st.cur.y) / st.cur.s };
        animateTo(clampPos(x - local.x * s, y - local.y * s, s));
        return;
      }
      lastTap = { t: now, x: x, y: y };
    }
    function resetSwipe() {
      if (st.img) st.img.el.style.opacity = '';
      ui.bg.style.opacity = '1';
    }
    function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y) || 1; }
  }

  /* ---------- start ---------- */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey) return;
    var el = e.target.closest('[data-au-lb]');
    if (!el || el.closest('dialog')) return;
    if (e.target.closest('a, button:not(.product-media-container__zoom-button), deferred-media, product-model')) return;
    e.preventDefault();
    open(el);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest && e.target.closest('[data-au-lb]');
    if (!el || el !== e.target || el.closest('dialog')) return;
    e.preventDefault();
    open(el);
  });
  document.addEventListener('pointerdown', function (e) {
    var el = e.target.closest && e.target.closest('[data-au-lb]');
    if (!el) return;
    /* warm the full-size file while the finger / mouse goes down */
    var img = el.querySelector('img');
    if (img && img.currentSrc) { var h = new Image(); h.src = sizedUrl(img.currentSrc, 2400); }
  }, { passive: true });

  function init() {
    prep();
    var main = document.querySelector('main');
    if (!main || !('MutationObserver' in window)) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; prep(); });
    }).observe(main, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('resize', function () { prep(); });
})();
